<template>
  <el-dialog
    :title="L10n('stock-info')"
    :visible="isVisible"
    :closeOnClickModal="false"
    append-to-body
    custom-class="dialog-long-form"
    @close="$emit('close', false)"
  >
    <el-tabs v-model="activeTab">
      <el-tab-pane
        v-for="mainTab in tabs"
        :key="mainTab.name"
        :name="mainTab.name"
      >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{mainTab.label}}</span>
        </template>
        <component
          :is="mainTab.component"
          :data="tabsData"
          isPreview
        />
      </el-tab-pane>
    </el-tabs>
    <template v-slot:footer>
      <button type="button" class="my-2 m-0 m-sm-2 btn btn-size-s btn-border grey btn-mobile-full" @click="$emit('close', false)">{{L10n('cancel')}}</button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'CheckStock',
  components: {
    'tab-stock': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQDialogAddToRFQ3/TabStock/Index'),
    'tab-supplier': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQDialogAddToRFQ3/TabSupplier/Index')
  },
  props: {
    isVisible: { type: Boolean },
    partID: { type: Number || String }
  },
  data () {
    return {
      activeTab: 'stock',
      tabs: [
        { label: this.L10n('card-stock'), name: 'stock', component: 'tab-stock' },
        { label: this.L10n('card-supplier-rfq'), name: 'supplier', component: 'tab-supplier' }
      ]
    }
  },
  computed: {
    tabsData () {
      return { partID: this.partID }
    }
  }
}
</script>

<style scoped>

</style>
